/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Fix: toon kortingslabel correct bij page load op basis van geselecteerde variant
(function() {
  function applyDiscountLabel(section) {
    if (!window.theme || !window.theme.showDiscount) return;

    var productJsonEl = section.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var data;
    try { data = JSON.parse(productJsonEl.innerHTML); } catch(e) { return; }

    var variant = data.product.variants.find(function(v) {
      return v.id === data.selected_variant_id;
    });
    if (!variant || !variant.compare_at_price || variant.price >= variant.compare_at_price) return;

    var label = section.querySelector('.product-label--on-sale');
    if (!label) return;

    var savings = window.theme.discountMode === 'percentage'
      ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'
      : '<span>' + window.Currency.formatMoney(variant.compare_at_price - variant.price, window.theme.moneyFormat) + '</span>';

    label.innerHTML = window.languages.collectionOnSaleLabel.replace('{{savings}}', savings);
    label.style.display = 'inline-block';
  }

  // Wacht tot het theme klaar is met initialiseren via variant:changed event
  document.addEventListener('variant:changed', function(e) {
    var section = e.target.closest('[data-section-type="product"]');
    if (section) applyDiscountLabel(section);
  }, true);

  // Fallback: probeer ook na een korte vertraging
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      document.querySelectorAll('[data-section-type="product"]').forEach(applyDiscountLabel);
    }, 500);
  });
})();


document.addEventListener('DOMContentLoaded', function () {
  const end = new Date('2026-11-02T09:00:00+01:00');

  function updateCountdown() {
    const el = document.getElementById('sale-days');
    const label = document.getElementById('sale-days-label');

    if (!el) return;

    const remaining = end.getTime() - Date.now();

    if (remaining <= 0) {
      el.textContent = '0';
      if (label) label.textContent = 'uur';
      return;
    }

    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);

    el.textContent = `${hours} uur en ${minutes} minuten`;
    if (label) label.textContent = '';
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});

